import React from 'react'

const LateCheckoutIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.64167 13.4167C6.825 13.4167 6.05937 13.2611 5.34479 12.95C4.63021 12.6389 4.00799 12.2184 3.47812 11.6885C2.94826 11.1587 2.52778 10.5365 2.21667 9.82187C1.90556 9.10729 1.75 8.34167 1.75 7.525C1.75 6.10556 2.20208 4.85382 3.10625 3.76979C4.01042 2.68576 5.1625 2.0125 6.5625 1.75C6.3875 2.7125 6.44097 3.65313 6.72292 4.57188C7.00486 5.49062 7.49097 6.29514 8.18125 6.98542C8.87153 7.67569 9.67604 8.16181 10.5948 8.44375C11.5135 8.72569 12.4542 8.77917 13.4167 8.60417C13.1639 10.0042 12.4931 11.1562 11.4042 12.0604C10.3153 12.9646 9.06111 13.4167 7.64167 13.4167Z'
      fill='currentColor'
    />
  </svg>
)

export default LateCheckoutIcon
